var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCohortDelete = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.793945,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#F0F0F0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.6667 14.7939L20.1894 20.9984C20.0825 22.3877 18.924 23.4605 17.5306 23.4605H14.4694C13.076 23.4605 11.9175 22.3877 11.8106 20.9984L11.3333 14.7939M22 13.4605C20.2681 12.6165 18.2091 12.1272 16 12.1272C13.7909 12.1272 11.7319 12.6165 10 13.4605M14.6667 12.1272V11.4605C14.6667 10.7242 15.2636 10.1272 16 10.1272C16.7364 10.1272 17.3333 10.7242 17.3333 11.4605V12.1272M14.6667 16.1272V20.1272M17.3333 16.1272V20.1272",
    stroke: "#868687",
    strokeLinecap: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCohortDelete);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/cohort_delete.8414fc167afb2110cbe8bed4d7186ddd.svg";